import React from "react";
import { UNINUMBERSSUB } from "./Constants";

class EssentialsFormatText extends React.Component {
  convertStringToUnicode(num) {
    let valuesConvert = "";

    for (let i = 0; i < num.length; ++i) {
      switch (parseInt(num[i])) {
        case 0:
          valuesConvert += UNINUMBERSSUB[0];
          break;

        case 1:
          valuesConvert += UNINUMBERSSUB[1];
          break;

        case 2:
          valuesConvert += UNINUMBERSSUB[2];
          break;

        case 3:
          valuesConvert += UNINUMBERSSUB[3];
          break;

        case 4:
          valuesConvert += UNINUMBERSSUB[4];
          break;

        case 5:
          valuesConvert += UNINUMBERSSUB[5];
          break;

        case 6:
          valuesConvert += UNINUMBERSSUB[6];
          break;

        case 7:
          valuesConvert += UNINUMBERSSUB[7];
          break;

        case 8:
          valuesConvert += UNINUMBERSSUB[8];
          break;

        case 9:
          valuesConvert += UNINUMBERSSUB[9];
          break;
      }
    }

    return valuesConvert;
  }

  preparerText(tempGrammar, keyPresNow) {
    //Programa para cada linha da gramática :
    let indexAllPipe = this.getAllIndexOf(tempGrammar, "|");
    let indexAllArrow = this.getAllIndexOf(tempGrammar, "→");
    let indexAllNumber = this.getAllIndexOf(tempGrammar, "_");
    let posAnalising =
      document.getElementById("grammar-text").selectionStart - 1;

    if (keyPresNow !== "Backspace" && keyPresNow !== "Delete") {
      if (
        !this.isFormat(tempGrammar, indexAllArrow) &&
        tempGrammar[posAnalising] &&
        (tempGrammar[posAnalising] !== "→" ||
          tempGrammar[posAnalising] !== "|") &&
        tempGrammar[posAnalising - 1] === "→"
      ) {
        return [
          tempGrammar.slice(0, posAnalising - 1) +
            " → " +
            tempGrammar.slice(posAnalising, tempGrammar.length),
          null,
        ];
      }

      if (
        !this.isFormat(tempGrammar, indexAllPipe) &&
        tempGrammar[posAnalising] &&
        (tempGrammar[posAnalising] !== "→" ||
          tempGrammar[posAnalising] !== "|") &&
        tempGrammar[posAnalising - 1] === "|"
      ) {
        return [
          tempGrammar.slice(0, posAnalising - 1) +
            " | " +
            tempGrammar.slice(posAnalising, tempGrammar.length),
          null,
        ];
      }

      if (
        !this.isFormat(tempGrammar, indexAllNumber) &&
        !/[0-9]/g.test(keyPresNow)
      ) {
        if (this.canTransform(tempGrammar, indexAllNumber)) {
          let position = 0;
          for (let pos of indexAllNumber) {
            let positionNum = pos + 1;
            let numUnicode = "";

            while (/[0-9]/g.test(tempGrammar[positionNum])) {
              numUnicode += tempGrammar[positionNum];
              ++positionNum;
            }

            tempGrammar = tempGrammar
              .split(tempGrammar[pos])
              .join("")
              .split(numUnicode)
              .join(this.convertStringToUnicode(numUnicode));
            position =
              keyPresNow !== " "
                ? pos + numUnicode.length + 1
                : pos + numUnicode.length;
          }

          return [tempGrammar, position];
        }
      }
    }

    return [tempGrammar, null];
  }

  eraserLetter(event, startPosClick) {
    let text = event.target.value;
    let pos =
      startPosClick !== 0 ? startPosClick - 1 : event.target.selectionStart - 1;

    if (event.key === "Backspace") {
      if (
        text[pos] === " " &&
        text[pos - 2] === " " &&
        (text[pos - 1] === "|" || text[pos - 1] === "→")
      ) {
        event.preventDefault();
        event.stopPropagation();

        return [
          text.substring(0, pos - 2) + text.substring(pos + 1, text.length),
          pos - 2,
        ];
      }

      if (UNINUMBERSSUB.includes(text[pos])) {
        event.preventDefault();
        event.stopPropagation();

        let afterPos = pos;
        while (UNINUMBERSSUB.includes(text[pos])) --pos;

        return [
          text.substring(0, pos) + text.substring(afterPos + 1, text.length),
          pos - 1 < 0 ? 0 : pos,
        ];
      }
    } else if (event.key === "Delete") {
      pos += 1;

      if (
        text[pos] === " " &&
        text[pos + 2] === " " &&
        (text[pos + 1] === "|" || text[pos + 1] === "→")
      ) {
        event.preventDefault();
        event.stopPropagation();

        return [
          text.substring(0, pos) + text.substring(pos + 3, text.length),
          pos,
        ];
      }

      if (
        /([A-Z]')|[A-Z]/g.test(text[pos]) &&
        UNINUMBERSSUB.includes(text[pos + 1])
      ) {
        event.preventDefault();
        event.stopPropagation();

        let afterPos;
        pos - 1 < 0 ? (afterPos = 0) : (afterPos = pos);
        while (UNINUMBERSSUB.includes(text[pos + 1])) ++pos;

        return [
          text.substring(0, afterPos) + text.substring(pos + 1, text.length),
          afterPos,
        ];
      }
    }
    return [event.target.value, null];
  }

  canTransform(tempGrammar, indexAllNumber) {
    for (let pos of indexAllNumber) {
      if (/([A-Z]')|[A-Z]/g.test(tempGrammar[pos - 1])) {
        let contPos = pos + 1;
        while (/[0-9]/g.test(tempGrammar[contPos])) {
          ++contPos;
          if (!/[0-9]/g.test(tempGrammar[contPos])) return true;
        }
      }
    }

    return false;
  }

  cursorUserPosition(event, startPosClick, posCursorUser) {
    if (posCursorUser !== null) {
      //setar a posição do cursor user interface:
      event.target.focus();
      event.target.setSelectionRange(posCursorUser, posCursorUser);
    }
  }

  getAllIndexOf(tempGrammar, symbol) {
    let index = [];
    for (let i = 0; i < tempGrammar.length; ++i) {
      if (tempGrammar[i] === symbol) index.push(i);
    }
    return index;
  }

  isFormat(tempGrammar, indexAll) {
    for (let indeP of indexAll) {
      if (
        tempGrammar[indeP] === "_" ||
        tempGrammar[indeP + 1] !== " " ||
        tempGrammar[indeP - 1] !== " "
      )
        return false;
    }
    return true;
  }
}

export default new EssentialsFormatText();
